import { Middleware, AnyAction } from '@reduxjs/toolkit'

import { isDebugPanelEnabled } from '../utils/cookies'

export interface ActionLogEntry {
  id: string
  type: string
  timestamp: number
  payload?: unknown
}

type ActionListener = (action: ActionLogEntry) => void

const MAX_BUFFER_SIZE = 200
const actionBuffer: ActionLogEntry[] = []
const listeners: Set<ActionListener> = new Set()

const generateId = (): string => crypto.randomUUID()

export const actionsLoggerMiddleware: Middleware = () => (next) => (action) => {
  if (isDebugPanelEnabled() && typeof action !== 'function') {
    const typedAction = action as AnyAction

    const entry: ActionLogEntry = {
      id: generateId(),
      type: typedAction.type || '[Unknown]',
      timestamp: Date.now(),
      payload: typedAction.payload,
    }

    actionBuffer.unshift(entry)

    if (actionBuffer.length > MAX_BUFFER_SIZE) {
      actionBuffer.pop()
    }

    listeners.forEach((listener) => listener(entry))
  }

  return next(action)
}

export const getBufferedActions = (): ActionLogEntry[] => [...actionBuffer]

export const clearBufferedActions = (): void => {
  actionBuffer.length = 0
}

export const subscribeToActions = (listener: ActionListener): (() => void) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
